var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.612 24.3542H30.0648L29.5165 23.8929C31.4357 21.9454 32.5912 19.4171 32.5912 16.6667C32.5912 10.5338 26.8922 5.5625 19.8615 5.5625C12.8308 5.5625 7.13184 10.5338 7.13184 16.6667C7.13184 22.7996 12.8308 27.7708 19.8615 27.7708C23.0146 27.7708 25.913 26.7629 28.1456 25.0887L28.6744 25.5671V26.9167L38.4664 35.4412L41.3845 32.8958L31.612 24.3542ZM19.8615 24.3542C14.9851 24.3542 11.0487 20.9204 11.0487 16.6667C11.0487 12.4129 14.9851 8.97917 19.8615 8.97917C24.738 8.97917 28.6744 12.4129 28.6744 16.6667C28.6744 20.9204 24.738 24.3542 19.8615 24.3542Z",
    fill: "#7A53FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0148726cfbf30f8aad080f5120d08ce9.svg";
export { ForwardRef as ReactComponent };